import { AvatarProps } from "@/shared/data-display/avatar";
import { PersonAvatarFragment } from "gql/graphql";
import { Hidable, isHidden, valueOrNull } from "@/shared/value";
import { HidableAvatarView } from "./hidable-avatar-view";
import { PersonAvatarById } from "../views/person-avatar-by-id";

/**
 * Данные приходят одним из трёх способов, и по вызову должно быть видно, чей это аватар:
 *
 * - `data` — человек уже загружен запросом страницы вместе с аватаром;
 * - `person` — человек загружен без аватара, за ним компонент сходит сам; закрытый
 *   защитой человек тоже приходит сюда, у него нет идентификатора, но есть отметка;
 * - `personId` — известен только идентификатор.
 *
 * Передавать больше одного нельзя, не передать ничего — тем более.
 */
export type PersonAvatarProps = AvatarProps &
  (
    | { data: Hidable<PersonAvatarFragment>; person?: never; personId?: never }
    | { person: Hidable<{ id: string }>; data?: never; personId?: never }
    | { personId: string | undefined; data?: never; person?: never }
  );

export function PersonAvatar({
  data,
  person,
  personId,
  ...avatarProps
}: PersonAvatarProps) {
  if (isHidden(data)) {
    return <HidableAvatarView {...avatarProps} data={data} />;
  }

  if (isHidden(person)) {
    return <HidableAvatarView {...avatarProps} data={person} />;
  }

  if (data) {
    return <HidableAvatarView {...avatarProps} data={data.avatar} />;
  }

  return (
    <PersonAvatarById
      {...avatarProps}
      personId={person ? valueOrNull(person)?.id : personId}
    />
  );
}
